var App = App || {};

App.PromosBand = (function ($) {
    "use strict";

    var winWidthTouchpoint,
        LgBp = 992;

    function init() {
        const MobileCarouselPromosBand = $(".component.component-promosband.sansCarousel");
        if (MobileCarouselPromosBand.length) {
            MobileCarouselPromosBand.each(function () {
                MobilePromosCarousels(MobileCarouselPromosBand);
            });
        }

        const DesktopCarouselPromosBand = $(".component.component-promosband.hasCarousel");
        if (DesktopCarouselPromosBand.length) {
            DesktopCarouselPromosBand.each(function () {
                DesktopPromosCarousels(DesktopCarouselPromosBand);
            });
        }

        $(".component.component-promosband").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".cardrow-wrapper", type: "animate__fadeInRight", stagger: 0 }
            ]
        });
    }

    function MobilePromosCarousels(PromosBand) {
        const mobileCarousel = PromosBand.find(".cardrow.mobile");
        const prevBtn = PromosBand.find(".visual-splide__arrow.previous");
        const nextBtn = PromosBand.find(".visual-splide__arrow.next");

        const mobileSplide = new Splide(mobileCarousel[0], {
            pagination: false,
            type: 'loop',
            fixedWidth: "213px",
            gap: "30px",
            drag: true,
            snap: false,
            mediaQuery: 'min',
            breakpoints: {
                576: {
                    destroy: true,
                },
            }
        });

        prevBtn.on("click", function () {
            mobileSplide.Components.Controller.go('<');
        });

        nextBtn.on("click", function () {
            mobileSplide.Components.Controller.go('>');
        });

        mobileSplide.on('ready active', function () {
            $(".component-promosband .cardrow.mobile .promosband-card.is-active:not(.splide__slide--clone) a").attr("tabindex", "0");
            $(".component-promosband .cardrow.mobile .promosband-card:not(.is-active) a").attr("tabindex", "-1");
            $(".component-promosband .cardrow.mobile .promosband-card.splide__slide--clone a").attr("tabindex", "-1");
        });

        mobileSplide.mount();
    }

    function DesktopPromosCarousels(PromosBand) {

        const desktopCarousel = PromosBand.find(".cardrow.desktop.carousel-True");
        const prevBtn = PromosBand.find(".visual-splide__arrow.previous");
        const nextBtn = PromosBand.find(".visual-splide__arrow.next");

        const desktopSplide = new Splide(desktopCarousel[0], {
            pagination: false,
            type: 'loop',
            fixedWidth: "350px",
            gap: "30px",
            drag: true,
            snap: false,
            breakpoints: {
                991: {
                    fixedWidth: "213px",
                    gap: "20px",
                },
            }
        });

        prevBtn.on("click", function () {
            desktopSplide.Components.Controller.go('<');
        });

        nextBtn.on("click", function () {
            desktopSplide.Components.Controller.go('>');
        });

        desktopSplide.on('ready active', function () {
            $(".component-promosband .cardrow.desktop .promosband-card.is-active:not(.splide__slide--clone) a").attr("tabindex", "0");
            $(".component-promosband .cardrow.desktop .promosband-card:not(.is-active) a").attr("tabindex", "-1");
            $(".component-promosband .cardrow.desktop .promosband-card.splide__slide--clone a").attr("tabindex", "-1");
        });

        desktopSplide.mount();

        //ensure repeated cards are never visible, which prevents unintuitive behavior in the slider
        var carouselWrapper = PromosBand.find(".cardrow-wrapper");
        var realCards = desktopCarousel.find(".promosband-card:not(.splide__slide--clone)");
        winWidthTouchpoint = $(window).width();
        if (winWidthTouchpoint < LgBp) {
            setMaxWidth(carouselWrapper, realCards, 20);
        } else {
            setMaxWidth(carouselWrapper, realCards, 30);
        }
        desktopSplide.on('resized', function () {
            if (winWidthTouchpoint < LgBp && $(window).width() >= LgBp) {
                winWidthTouchpoint = $(window).width();
                setMaxWidth(carouselWrapper, realCards, 30);
            }
            if (winWidthTouchpoint >= LgBp && $(window).width() < LgBp) {
                winWidthTouchpoint = $(window).width();
                setMaxWidth(carouselWrapper, realCards, 20);
            }
        });
    }

    function setMaxWidth(carouselWrapper, realCards, margin) {
        var maxWidth = 0;
        realCards.each(function () {
            maxWidth += $(this).outerWidth(true);
        });
        maxWidth -= margin;
        carouselWrapper.css("max-width", maxWidth);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PromosBand.init();
});